import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Helmet } from "react-helmet-async";
import CalculatorCard from "../../components/cards/CalculatorCard";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Loader from "../../components/loader";
import { useTranslate } from "../../context/TranslationContext";
import { useGetContentQuery } from "../../redux/Apis/Content";
import { useStaticData } from "../../utils/data";

const FitnessTest = () => {
  const { FITNESSTEST } = useStaticData();
  const { t } = useTranslate("footer");

  const { data: testVideos, isLoading: isTestVideosLoading } =
    useGetContentQuery({
      search: "fitness_tests",
    });

  // useEffect(() => {
  //   setMetaTags(
  //     "Traineego | Buy or Create Automated Courses & Tracks for Fitness & Wellness",
  //     "Create, manage, and sell your own courses and tracks, or buy high-quality content. Empower your career through automation and passive income today!",
  //   );
  // }, []);

  if (isTestVideosLoading) {
    return (
      <>
        <Header />
        <Loader loading={true} />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Fitness Tests | Assess Strength, Cardio & Flexibility | Traineego
        </title>

        <meta
          name="description"
          content="Evaluate your fitness level with cardio, strength, flexibility, balance, and performance assessments designed to track your progress."
        />

        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://traineego.com/fitness-tests" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Fitness Tests | Assess Strength, Cardio & Flexibility",
            url: "https://traineego.com/fitness-tests",
            description:
              "Evaluate your fitness level with cardio, strength, flexibility, balance, and performance assessments designed to track your progress.",
            publisher: {
              "@type": "Organization",
              name: "Traineego",
              url: "https://traineego.com",
            },
          })}
        </script>
      </Helmet>
      <Header />
      <section className="banner" style={{ textAlign: "left" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="text-uppercase">{t("fitnessTest")}</h2>
            </div>
            {FITNESSTEST.map((item) => (
              <div className="col-lg-4 col-md-6 my-3">
                <CalculatorCard data={item} content={testVideos} />
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default FitnessTest;
